const tablist = [
    {
        selector: '[role=tablist]',
        path: { filename: 'tablist' },
    },
];

export { tablist };
